import React, { useRef } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import {
  Button,
  Input, Table, Space,
} from 'antd';

import {
  FilterOutlined,
} from '@ant-design/icons';

import styles from './index.module.scss';
import stylesLayout from '../../common/layout.module.scss';

const
  SessionsTable = ({
    items,
    onAction,
  }) => {
    const searchInput = useRef(null);

    const handleSearch = (confirm) => {
      confirm();
    };

    const handleReset = (clearFilters) => {
      clearFilters();
    };

    const getColumnSearchProps = (dataIndex) => ({
      filterDropdown: ({
        // eslint-disable-next-line react/prop-types
        setSelectedKeys, selectedKeys, confirm, clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={searchInput}
            placeholder="Buscar..."
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(confirm)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(confirm)}
              icon={<FilterOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Filtrar
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => handleReset(clearFilters)}
              style={{ width: 90 }}
            >
              Limpiar
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => <FilterOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
      onFilter: (value, record) => (record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : ''),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.current.select(), 100);
        }
      },
      render: (text) => text,
    });
    const columns = [
      {
        title: 'Email enviado',
        dataIndex: 'access_mail_sent_to_user',
        align: 'center',
        key: 'access_mail_sent_to_user',
        render: (a) => (
          a ? 'Si' : 'No'
        ),
        sorter: (a, b) => (a.name < b.name ? -1 : 1),
      },
      {
        title: 'Nombre',
        dataIndex: 'name',
        key: 'name',
        ...getColumnSearchProps('name'),
        render: (name, r) => (
          <div
            className={`${styles.link} ${stylesLayout.link}`}
            role="button"
            tabIndex={0}
            onKeyPress={() => onAction('view', r.hash, r.customer_hash)}
            onClick={() => onAction('view', r.hash, r.customer_hash)}
          >
            {name}
          </div>
        ),
        sorter: (a, b) => (a.name < b.name ? -1 : 1),
      },
      {
        title: 'Tipo',
        dataIndex: 'typeTr',
        key: 'typeTr',
        align: 'center',
        ...getColumnSearchProps('typeTr'),
        render: (typeTr) => typeTr,
        sorter: (a, b) => (a.typeTr < b.typeTr ? -1 : 1),
      },
      {
        title: 'Sol',
        dataIndex: 'sun',
        key: 'sun',
        align: 'center',
        ...getColumnSearchProps('sun'),
        render: (sun) => sun,
        sorter: (a, b) => (a.sun < b.sun ? -1 : 1),
      },
      {
        title: 'Luna',
        dataIndex: 'moon',
        key: 'moon',
        align: 'center',
        ...getColumnSearchProps('moon'),
        render: (moon) => moon,
        sorter: (a, b) => (a.moon < b.moon ? -1 : 1),
      },
      {
        title: 'Ascendente',
        dataIndex: 'ascendant',
        key: 'ascendant',
        align: 'center',
        ...getColumnSearchProps('ascendant'),
        render: (ascendant) => ascendant,
        sorter: (a, b) => (a.ascendant < b.ascendant ? -1 : 1),
      },
      {
        title: 'Asignada a',
        dataIndex: ['assignee', 'name'],
        key: 'assignee_name',
        align: 'center',
        render: (name) => name,
        sorter: (a, b) => (a.assignee.name < b.assignee.name ? -1 : 1),
      },
      {
        title: 'Fecha',
        dataIndex: 'date',
        key: 'date',
        align: 'center',
        render: (date) => date && moment.utc(date).local().format('DD/MM HH:mm'),
        sorter: (a, b) => moment(b.date || '2050-01-01').format('X') - moment(a.date || '2050-01-01').format('X'),
      },
      {
        title: 'Creada',
        dataIndex: 'created_at',
        key: 'created_at',
        align: 'center',
        render: (createdAt) => moment.utc(createdAt).fromNow(),
        sorter: (a, b) => moment(b.created_at).format('X') - moment(a.created_at).format('X'),
      },
      {
        title: 'Actualizada',
        dataIndex: 'updated_at',
        key: 'updated',
        align: 'center',
        render: (updatedAt) => moment.utc(updatedAt).fromNow(),
        sorter: (a, b) => moment(b.updated_at).format('X') - moment(a.updated_at).format('X'),
      },
      {
        title: '',
        dataIndex: 'hash',
        key: 'hash',
        render: (hash) => (
          <a
            href={`https://site.almaceleste.cl/sesion/${hash}`}
            target="_ac_session"
            className={`${styles.link} ${stylesLayout.link}`}
            role="button"
            tabIndex={0}
          >
            Ver
          </a>
        ),
      },
    ];
    return (
      <div className={styles.table}>
        <Table
          rowClassName={(r) => (r.access_mail_sent_to_user ? styles.sent : '')}
          size="small"
          hideOnSinglePage
          pagination={{ defaultPageSize: 500 }}
          locale={{ emptyText: 'Sin datos' }}
          columns={columns}
          dataSource={items.map((d) => ({
            key: d.id,
            typeTr: d.type_tr,
            ...d,
          }))}
        />
      </div>
    );
  };

SessionsTable.defaultProps = {
  onAction: () => { },

};

SessionsTable.propTypes = {
  items: PropTypes.array.isRequired,
  onAction: PropTypes.func,
};
export default SessionsTable;
